import styled from "styled-components";

export const Wrapper = styled.div`
  width: 451px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

export const IconCircle = styled.div<{ bgColor: string }>`
  width: 140px;
  height: 140px;
  padding: 0 38px;
  border-radius: 50%;
  background: ${({ bgColor }) => bgColor};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IconImage = styled.img`
  width: 64px;
  height: 64px;
  object-fit: contain;
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 20px;
  line-height: 32px;
  font-weight: 600;
  color: #060422;
  text-align: center;
`;

export const Description = styled.p`
  margin: 0 0 18px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  color: #717680;
  text-align: center;
`;

export const ActionColumn = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ActionButton = styled.button<{ variant: "primary" | "secondary" }>`
  width: 100%;
  height: 44px;
  border-radius: 8px;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: filter 0.15s ease-in-out;

  ${({ variant }) =>
    variant === "primary"
      ? `
        border: none;
        color: #fff;
        background: #2233ea;
      `
      : `
        border: 1px solid #d0d5dd;
        color: #060422;
        background: #ffffff;
      `}

  &:hover {
    filter: brightness(0.98);
  }

  &:active {
    filter: brightness(0.95);
  }
`;

export const modalWidth = "531px";
